import React from 'react';
import ProductsShowcase from './products/Products';

const Products: React.FC = () => {
  return <ProductsShowcase />;
};

export default Products;